import React, { useEffect, useState } from 'react'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  useListController,
  useStore,
  BooleanInput
} from 'react-admin'
import { Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'

export const CardList = (props) => {
  const translate = useTranslate()
  const { setSort, isFetching } = useListController()
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const [isSorting, setIsSorting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resourceName]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resourceName])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  useEffect(() => {
    if (isSorting && isFetching) {
      setIsLoading(true)
    } else if (isLoading && isSorting && !isFetching) {
      setIsLoading(false)
      setIsSorting(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSorting, isFetching])

  const onClickSort = (sort) => {
    setSort(sort)
    setIsSorting(true)
  }

  const cardFilters = [
    <TextInput label={translate('ra.field.id')} source='id' defaultValue='' />,
    <TextInput label={translate('ra.field.short_name')} source='short_name' defaultValue='' />,
    <TextInput label={translate('ra.field.long_name')} source='long_name' defaultValue='' />,
    <BooleanInput label={translate('ra.field.is_active')} source='is_active' defaultValue={true} />,
  ]

  const hasPermissions = () => {
    return permissions?.options?.revision ||
      permissions?.hasShow ||
      permissions?.hasEdit ||
      permissions?.options?.delete
  }

  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.card')}>
        <List {...props} component='div' filters={cardFilters} actions={<ListViewTopToolbar hasCreate={permissions?.hasCreate} />}>
          <Datagrid rowClick='show' setSort={onClickSort} isLoading={isLoading}>
            <TextField source='id' label={translate('ra.field.id')} />
            <TextField source='short_name' label={translate('ra.field.short_name')} />
            <TextField source='long_name' label={translate('ra.field.long_name')} />
            {hasPermissions() && (
              <ListViewActionsButtons label={translate('ra.action.actions')} fieldsName={['short_name']} genderElement='femenine' disableRevision/>
            )}
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}
